module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10051.79da892b.jpg";